var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEslint2SvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_eslint2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.027,30,2.39,20.422l2.979-14L18.973,2,29.61,11.578l-2.979,14L13.027,30ZM7.883,18.642l6.342,5.7L22.337,21.7l1.781-8.344L17.775,7.644,9.663,10.3,7.883,18.642Z",
    style: {
      fill: "#4b32c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.72,25.915H10.28L4.554,16,10.28,6.085H21.72L27.446,16,21.72,25.915Zm-9.426-3.491h7.413L23.419,16,19.707,9.576H12.293L8.593,16l3.7,6.424Z",
    style: {
      fill: "#8080f2"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEslint2SvgrepoCom);
export default __webpack_public_path__ + "static/media/eslint2-svgrepo-com.248d0a406fcaa0bd786a32bf778960c7.svg";
export { ForwardRef as ReactComponent };